import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import store from './store'
import router from './router'
import Vuelidate from 'vuelidate'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(Vuelidate)


Vue.config.productionTip = false

import "@/mixins/imagePathMixin";

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_URL;

axios.interceptors.request.use((config) => {
    store.commit('loading', true);
    return config;
    }, (error) => {
    store.commit('loading', false);
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    store.commit('loading', false);
    return response;
    }, (error) => {
    store.commit('loading', false);
    return Promise.reject(error);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
